import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { Loader2, XCircle, CheckCircle2 } from "lucide-react";
import { euro } from "../lib/format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OwnerCancelPage() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [booking, setBooking] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/bookings/${id}/link-info`, { params: { t: token } })
      .then((r) => setBooking(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Link non valido"));
  }, [id, token]);

  const cancel = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/bookings/${id}/link-cancel`, { token });
      setBooking(r.data);
    } catch (e) {
      setError(e.response?.data?.detail || "Errore");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1F3A] text-[#F7F2EC] flex items-center justify-center px-4 noise-overlay relative">
      <div className="relative z-10 w-full max-w-md" data-testid="owner-cancel-page">
        <p className="font-display font-black text-6xl leading-none">BANY</p>
        <p className="font-mono-alt text-[11px] tracking-[0.4em] uppercase opacity-70 mb-10">Annulla prenotazione</p>

        {error && <p data-testid="owner-cancel-error" className="bg-[#F7F2EC] text-[#0B1F3A] rounded-xl px-5 py-4 text-sm">{error}</p>}
        {!error && !booking && <Loader2 className="w-6 h-6 animate-spin" />}

        {booking && (
          <div className="rounded-2xl bg-[#F7F2EC] text-[#1A1416] p-6">
            <p className="font-display text-2xl font-bold">{booking.name}</p>
            <p className="text-[#6F6466] text-sm mt-1">{booking.date} ore <span className="text-[#0B1F3A] font-semibold">{booking.time}</span> · {booking.service_names.join(" + ")} · €{euro(booking.total)}</p>
            <p className="text-xs text-[#9A8F90] font-mono-alt mt-2">Tel. {booking.phone} · #{booking.id}</p>

            {booking.status === "cancelled" ? (
              <p data-testid="owner-cancel-done" className="mt-6 inline-flex items-center gap-2 text-sm text-[#0B1F3A] font-semibold"><XCircle className="w-4 h-4" /> Prenotazione annullata. Lo slot è di nuovo libero.</p>
            ) : (
              <button
                data-testid="owner-cancel-confirm-button"
                onClick={cancel}
                disabled={busy}
                className="mt-6 w-full rounded-full bg-[#0B1F3A] text-[#F7F2EC] py-4 text-sm font-bold uppercase tracking-[0.15em] hover:bg-[#071528] transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
              >
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />} Conferma annullamento
              </button>
            )}
          </div>
        )}

        <Link to="/admin" data-testid="owner-cancel-admin-link" className="inline-block mt-8 text-xs uppercase tracking-[0.3em] opacity-70 hover:opacity-100">Vai all'agenda →</Link>
      </div>
    </div>
  );
}
